<template>
    <div class="content">
        <div class="container">
            <h1 class="mb-5">
                Setting
            </h1>
            <nav-setting tab="legal"></nav-setting>
            <div class="row">
                <div class="col-3">
                    <H4>Pages</H4>

                    <p>You can create your own legal pages, or create them from templates and customize them. The
                        templates aren't legal advice and need to be customized for your store.</p>

                    <p>By using these templates you agree that you've read and agreed to the</p>
                </div>
                <div class="col-9">
                    <card-box>
                        <card-title>Refund policy</card-title>
                        <p class="text-muted">When saved, customers can see a link to this on checkout footer, order
                            review page, and menus (optional).</p>
                        <editor :init="customToolbar" :key="editorKey + 'returns'"
                                api-key="gdhlyynmp3tt3gvuf2g7z30zs6dba2kuo60nk82wfm3pf7rn"
                                v-model="page.returns.detail"></editor>

                        <button @click="getTemplate('returns')" class="float-right mt-3 btn btn-outline-secondary">
                            Created from template
                        </button>
                        <button @click="updatePage('returns')" class="mt-3 btn btn-success">Save</button>

                    </card-box>

                    <card-box>
                        <card-title>Privacy policy
                        </card-title>
                        <p class="text-muted">When saved, customers can see a link to this on checkout footer, order
                            review page, and menus (optional).</p>
                        <editor :init="customToolbar" :key="editorKey + 'privacy'"
                                api-key="gdhlyynmp3tt3gvuf2g7z30zs6dba2kuo60nk82wfm3pf7rn"
                                v-model="page.privacy.detail"></editor>
                        <button @click="getTemplate('privacy')" class="mt-3 float-right btn btn-outline-secondary">
                            Created from template
                        </button>
                        <button @click="updatePage('privacy')" class="mt-3 btn btn-success">Save</button>


                    </card-box>


                    <card-box>
                        <card-title>Terms of service

                        </card-title>
                        <p class="text-muted">When saved, customers can see a link to this on checkout footer, order
                            review page, and menus (optional).</p>
                        <editor :init="customToolbar" :key="editorKey + 'terms'"
                                api-key="gdhlyynmp3tt3gvuf2g7z30zs6dba2kuo60nk82wfm3pf7rn"
                                v-model="page.terms.detail"></editor>
                        <button @click="getTemplate('terms')" class="mt-3 float-right btn btn-outline-secondary">Created
                            from
                            template
                        </button>
                        <button @click="updatePage('terms')" class="mt-3  btn btn-success">Save</button>

                    </card-box>


                    <card-box>
                        <card-title>Shipping policy
                        </card-title>
                        <p class="text-muted">When saved, customers can see a link to this on product pages, cart,
                            checkout, checkout footer, and menus (optional).

                        </p>
                        <editor :init="customToolbar"  :key="editorKey + 'shipping'"
                                api-key="gdhlyynmp3tt3gvuf2g7z30zs6dba2kuo60nk82wfm3pf7rn"
                                v-model="page.shipping.detail"></editor>
                        <button @click="getTemplate('shipping')" class="mt-3 float-right btn btn-outline-secondary">
                            Created from template
                        </button>
                        <button @click="updatePage('shipping')" class="mt-3 btn btn-success">Save</button>

                    </card-box>

                    <card-box>
                        <card-title>Payment methods
                        </card-title>
                        <p class="text-muted">When saved, customers can see a link to this on product pages, cart,
                            checkout, checkout footer, and menus (optional).

                        </p>
                        <editor :init="customToolbar" :key="editorKey + 'payment'"
                                api-key="gdhlyynmp3tt3gvuf2g7z30zs6dba2kuo60nk82wfm3pf7rn"
                                v-model="page.payment.detail"></editor>
                        <button @click="getTemplate('payment')" class="mt-3 float-right btn btn-outline-secondary">
                            Created from template
                        </button>
                        <button @click="updatePage('payment')" class="mt-3 btn btn-success">Save</button>

                    </card-box>

                    <card-box>
                        <card-title>Copyright Dispute Policy</card-title>
                        <p class="text-muted">When saved, customers can see a link to this on product pages, cart,
                            checkout, checkout footer, and menus (optional).

                        </p>
                        <editor :init="customToolbar"  :key="editorKey + 'dmca'"
                                api-key="gdhlyynmp3tt3gvuf2g7z30zs6dba2kuo60nk82wfm3pf7rn"
                                v-model="page.dmca.detail"></editor>
                        <button @click="getTemplate('dmca')" class="mt-3 float-right btn btn-outline-secondary">Created
                            from template
                        </button>
                        <button @click="updatePage('dmca')" class="mt-3 btn btn-success">Save</button>

                    </card-box>

                    <card-box>
                        <card-title>Help
                        </card-title>
                        <p class="text-muted">When saved, customers can see a link to this on product pages, cart,
                            checkout, checkout footer, and menus (optional).

                        </p>
                        <editor :init="customToolbar" :key="editorKey + 'help'"
                                api-key="gdhlyynmp3tt3gvuf2g7z30zs6dba2kuo60nk82wfm3pf7rn"
                                v-model="page.help.detail"></editor>
                        <button @click="getTemplate('help')" class="mt-3 float-right btn btn-outline-secondary">Created
                            from template
                        </button>
                        <button @click="updatePage('help')" class="mt-3 btn btn-success">Save</button>

                    </card-box>

                    <card-box>
                        <card-title>About Us
                        </card-title>
                        <p class="text-muted">When saved, customers can see a link to this on product pages, cart,
                            checkout, checkout footer, and menus (optional).

                        </p>
                        <editor :init="customToolbar" :key="editorKey + 'about'"
                                api-key="gdhlyynmp3tt3gvuf2g7z30zs6dba2kuo60nk82wfm3pf7rn"
                                v-model="page.about.detail"></editor>
                        <button @click="getTemplate('about')" class="mt-3 float-right btn btn-outline-secondary">Created
                            from template
                        </button>
                        <button @click="updatePage('about')" class="mt-3 btn btn-success">Save</button>

                    </card-box>
                    <card-box>
                        <card-title>Contact
                        </card-title>
                        <p class="text-muted">When saved, customers can see a link to this on contact page (optional).

                        </p>
                        <editor :init="customToolbar" :key="editorKey + 'contact'"
                                api-key="gdhlyynmp3tt3gvuf2g7z30zs6dba2kuo60nk82wfm3pf7rn"
                                v-model="page.contact.detail"></editor>
                        <button @click="getTemplate('contact')" class="mt-3 float-right btn btn-outline-secondary">
                            Created
                            from template
                        </button>
                        <button @click="updatePage('contact')" class="mt-3 btn btn-success">Save</button>

                    </card-box>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Editor from '@tinymce/tinymce-vue';
    import NavSetting from "../components/NavSetting";
    import CardTitle from "../components/CardTitle";
    import CardBox from "../components/CardBox";

    export default {
        name: "LegalPage",
        components: {CardBox, CardTitle, NavSetting, Editor},
        data: function () {
            return {
                editorKey: 0,
                customToolbar: {
                    height: 500,
                    menubar: true,
                    plugins: [
                        'advlist autolink lists link image charmap print preview anchor textcolor',
                        'searchreplace visualblocks code fullscreen',
                        'insertdatetime media table paste code help wordcount'
                    ],
                    toolbar: 'undo redo | formatselect | bold italic forecolor  image  | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat code '
                },
                page: {
                    returns: {detail: '', name: ''},
                    terms: {detail: '', name: ''},
                    shipping: {detail: '', name: ''},
                    privacy: {detail: '', name: ''},
                    about: {detail: '', name: ''},
                    payment: {detail: '', name: ''},
                    contact: {detail: '', name: ''},
                    dmca: {detail: '', name: ''},
                    help: {detail: '', name: ''},
                }
            }
        },
        methods: {
            getPage: function (slug) {
                let vm = this
                this.$http.get(this.$config.api + 'page/' + slug).then(function (res) {
                    //    console.log(res.data)
                    vm.page[slug] = res.data

                });
            },
            getTemplate:  function (slug) {
                let vm = this
                let name = this.page[slug].name

                this.$swal({
                    title: 'Create from template?',
                    text: 'Your current ' + name + ' will be replaced with template content.',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes Replace it!',
                    cancelButtonText: 'No, Keep it!',
                    showCloseButton: true,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                        this.$http.get(this.$config.api + 'page/template/' + slug).then(function (res) {
                            //  let name = slug.charAt(0).toUpperCase() + slug.slice(1)

                            vm.page[slug].detail = res.data.content

                        });
                    }
                })


            },
            getCss: async function () {
                let vm = this
                this.$http.get(this.$config.api + 'css').then(function (res) {
                    vm.customToolbar.content_css = res.data.join(',')
                    vm.editorKey = vm.editorKey + 1
                });
            },
            updatePage: function (slug) {
                let vm = this
                let post = {'detail': vm.page[slug].detail, 'slug': slug}
                let name = this.page[slug].name

                this.$http.post(this.$config.api + 'page', post).then(function () {
                    vm.$swal(name + ' page saved')
                });
            }
        },
        async mounted() {
            //  console.log(this.page)
            await this.getCss()
            this.getPage('returns')

            this.getPage('terms')
            this.getPage('shipping')
            this.getPage('privacy')
            this.getPage('payment')
            this.getPage('about')
            this.getPage('contact')
            this.getPage('dmca')
            this.getPage('help')
        }
    }
</script>

<style scoped>

</style>